import React, { PropsWithChildren } from 'react';
import { Button, ButtonProps } from '@progress/kendo-react-buttons';
import { Window, WindowActionsBar } from '@progress/kendo-react-dialogs';
import { FpFormattedMessage } from 'locales/FpFormattedMessage';
import { WindowProps } from '@progress/kendo-react-dialogs/dist/npm/WindowProps';

export type FpSimpleConfirmProps = {
  title: string
  onConfirm: () => void
  onClose: () => void
  confirmButtonLook?: ButtonProps['fillMode']
} & PropsWithChildren<any> & WindowProps

export function FpSimpleConfirm(props: FpSimpleConfirmProps) {
  return (
    <Window
      title={props.title}
      onClose={props.onClose}
      draggable
      resizable={false}
      maximizeButton={() => <div />}
      minimizeButton={() => <div />}
      width={600}
      modal
      {...props}
    >
      {props.children}
      <WindowActionsBar layout="stretched">
        <Button onClick={props.onClose} fillMode="outline" themeColor="primary">
          <FpFormattedMessage id="dialog.cancel" />
        </Button>
        <Button onClick={props.onConfirm} fillMode={props.confirmButtonLook || 'outline'} themeColor="primary">
          <FpFormattedMessage id="dialog.ok" />
        </Button>
      </WindowActionsBar>
    </Window>
  );
}
